import { useTranslation } from 'react-i18next';
import { Star } from 'lucide-react';

interface RatingInputProps {
  label: string;
  value: number;
  onChange: (rating: number) => void;
  disabled?: boolean;
}

export function RatingInput({ label, value, onChange, disabled }: RatingInputProps) {
  const { t } = useTranslation();
  return (
    <div className="rating-input">
      <label className="input-label">{label}</label>
      <div className="stars">
        {[1, 2, 3, 4, 5].map((star) => (
          <button
            key={star}
            className={`star ${star <= value ? 'filled' : ''}`}
            onClick={() => onChange(star === value ? 0 : star)}
            disabled={disabled}
            type="button"
            aria-label={t('app.ratingInput.starLabel', { count: star })}
          >
            <Star size={24} fill={star <= value ? 'currentColor' : 'none'} aria-hidden="true" />
          </button>
        ))}
      </div>
    </div>
  );
}
